<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {

    }
  },
  created() {
    console.log(this.$router, 'this.$router.path');
    // if (this.$router.path !== "/home") {
    //   this.$router.replace("home")
    // }
    window.addEventListener(
      "countKey",
      (e) => { // e代表存储的数据 { a:1 }
        // JSON.parse(e.a)
        console.log(e,'eeeee');
      },
      false
    );

  },
  watch: {
    
  },

  methods: {

  }
}
</script>


<style lang="scss">
	@import '@/global.scss';
</style>
<style >
#app,
body {
  margin: 0;
  padding: 0;
  border: 0;
  /* overflow-x: hidden; */

  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}

/* #app{
  padding-bottom: 50px;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue